import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { Box, Typography, Grid2, useTheme } from '@mui/material';
import { useParams } from "react-router-dom";
import { useGetNcrOpenByCategoryQuery } from "store/slices/apis/qualityDashboardSlice";
import NcrPopup from './NcrPopup';
import { useState } from 'react';



const NCROpenStatusGraph = () => {

  const theme = useTheme();
  const { projectId } = useParams();
  const [popupData, setPopupData] = useState(null);
  const [open, setOpen] = useState(false);




  const { data, isLoading } = useGetNcrOpenByCategoryQuery({ projectId });
  const openCategoryData = data?.data || [];





  const predefinedColors = [
    '#3E756D', '#FFBF00', '#C05222', '#415385', '#FF634C', '#8E44AD', '#2ECC71', '#E67E22', '#3498DB'
  ];

  const pieData = openCategoryData.map((item, idx) => ({
    y: item?.percentage,
    value: item?.percentage,
    color: predefinedColors[idx % predefinedColors.length],
    cat: item?.category,
  }));






  const total = openCategoryData.reduce((acc, item) => acc + item.count, 0);

  const chartOptions = {
    chart: {
      type: 'pie',
    },
    title: {
      text: null,
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        innerSize: '60%',
        showInLegend: false,
        borderWidth: 0,
        borderRadius: 0,
        dataLabels: {
          enabled: false,
          connectorWidth: 0,
        },
        point: {
          events: {
            click: function () {
              setPopupData(this?.cat);
              setOpen(true);
            }
          }
        }
      }
    },

    tooltip: {
      useHTML: true,
      formatter: function () {
        return `
      <b>${this.series.name}</b><br/>
      ${this.point.cat}: <b>${this.point.y}%</b>
    `;
      },
    },

    series: [
      {
        name: 'Open NCR',
        sliced: false,
        selected: false,
        data: pieData
      },
    ],
    credits: {
      enabled: false,
    },
  };

  return (
    <>
      <Box sx={{ margin: '0 auto', p: 2.5 }}>
        <Typography variant="body" sx={{ fontWeight: 500, fontSize: "18px", lineHeight: "100%", letterSpacing: '-0.4px', color: `${theme?.customSettings?.themeColor}` }}>
          Distribution of NCR with Open Status Chart
        </Typography>
        <Typography sx={{ mt: "5px", color: "#5052588A", fontSize: "14px", lineHeight: "100%", letterSpacing: '-0.4px', }}>
          Monitor quality metrics by evaluating the distribution of open NCRs to identify bottlenecks and enhance corrective action planning
        </Typography>
      </Box>

      {(!isLoading && total === 0) ? (
        <Box
          sx={{
            width: '100%',
            height: '300px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'white',
            borderRadius: '12px',
            mt: 2
          }}
        >
          <Typography sx={{ fontSize: '16px', color: '#999' }}>
            No data available to display the chart.
          </Typography>
        </Box>
      ) : (

        <Grid2 container spacing={4} alignItems="center" justifyContent="center">
          {/* Chart */}
          <Grid2 xs={12} md={6}>
            <Box sx={{ position: 'relative', width: '100%', maxWidth: 400, margin: '0 auto' }}>
              <HighchartsReact highcharts={Highcharts} options={chartOptions} />
              <Box
                sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  textAlign: 'center',
                }}
              >
                <Typography variant="body1" sx={{ fontWeight: 500, color: "#737373", fontSize: "14px" }}>
                  Open NCR
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 700, color: "#0A0A0A", fontSize: "24px", lineHeight: "28px" }}>
                  {total}
                </Typography>
              </Box>
            </Box>
          </Grid2>

          {/* Right Side Labels */}
          <Grid2 xs={12} md={6}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 2 }}>
              {openCategoryData.map((item, index) => (
                <Box
                  key={index}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                  }}
                >
                  <Box
                    sx={{
                      width: 14,
                      height: 14,
                      backgroundColor: predefinedColors[index % predefinedColors.length],

                    }}
                  />
                  <Typography variant="body1" sx={{
                    fontWeight: 500,
                    fontSize: '16px',
                    lineHeight: '100%',
                    letterSpacing: '-0.4px'
                  }}>
                    {item.category} :
                  </Typography>
                  <Typography sx={{
                    fontWeight: 500,
                    fontSize: '16px',
                    lineHeight: '100%',
                    color: "#182A4E",
                    letterSpacing: '-0.4px'
                  }}>
                    {item.count}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Grid2>
        </Grid2>
      )}
      {open &&
        <NcrPopup title="Distribution of NCR with Open Status" value={popupData} status="DistributedOpenNcr" onOpen={open} onClose={() => setOpen(false)} />
      }
    </>
  );
};

export default NCROpenStatusGraph;


